/**
 * DatetimeFieldType — data + godzina. Storage: PG TIMESTAMPTZ. Format: ISO 8601.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function DatetimeInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  // datetime-local oczekuje formatu YYYY-MM-DDTHH:MM (bez sekund i strefy)
  const localValue = (() => {
    if (typeof value !== 'string' || !value) return '';
    return value.slice(0, 16);
  })();

  return (
    <input
      type="datetime-local"
      value={localValue}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled}
      autoFocus={autoFocus}
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const DatetimeFieldType: FieldTypeDefinition = {
  type: 'datetime',
  renderInput: (props) => <DatetimeInput {...props} />,
  renderCell: (_field, value) => {
    if (typeof value !== 'string' || !value) return '';
    try {
      return new Date(value).toLocaleString('pl-PL');
    } catch {
      return value;
    }
  },
  defaultValue: null,
};
